<template>
  <li class="cart">

      <span class="loader" v-show="cart.IsRemoving"></span>

      <div class="cart-image">
          <img class="img-responsive"
               v-if="cart.Product.HasImage == true"
               v-bind:src="cart.Product.Image | correctImgUrl" 
               v-bind:alt="cart.Product.Description"/>

          <img class="img-responsive"
               v-if="cart.Product.HasImage == false"
               v-bind:src="state.settings.MissingImage | correctImgUrl" 
               v-bind:alt="cart.Product.Description"/>
      </div>
      <div class="cart-description">
          <div class="form-group">
              <a v-bind:href="'/' + state.settings.customerId + '/product/index/' + cart.Product.Id">
                  {{ productTitle }}

                  <span v-if="cart.Product.Format">
                      <br />
                      {{cart.Product.Format}}
                  </span>
                  <br v-if="hasManufacturer || hasCustomFormat"/>
                  <span v-if="hasManufacturer">
                      {{ cart.Product.Manufacturer }}
                      -
                  </span>
                  <span v-if="hasCustomFormat" class="text-capitalize">
                      {{ cart.Product.CustomFormat }}
                  </span>
              </a>
          </div>

          <div class="form-group" v-if="state.settings.ShowOOS && cart.Product.OnHand <= 0">
              <span class="text-danger">
                  {{ outOfStock }}
              </span>                
          </div>

          <div class="form-group">
              <label for="qty">
                  {{ getLabel('Prod_Quantity') }}
              </label>
              <div class="input-group">
                  <input type="number" class="form-control qty" required=""
                         v-bind:class="{'error': errors.first('qty' + cart.Id)}"
                         v-validate
                         v-bind:id="'qty' + cart.Id"
                         v-bind:name="'qty' + cart.Id"                           
                         v-bind:placeholder="getLabel('Prod_Quantity')"
                         v-model="cart.Qty" />

                  <span class="input-group-btn">
                      <button class="btn btn-primary update-cart"
                              type="button"
                              @click="updateCart($event)">
                          {{ getLabel('update') }}

                          <img src="/images/default/spinner-inverse-xs.gif" alt="loading"
                               v-show="cart.IsUpdating == true"/>

                      </button>
                  </span>
              </div>
          </div>

          <div class="form-group" v-if="state.settings.ShowPrice == true">
              <label>
                  {{ getLabel('_unitprice') }}: ${{ cart.UnitPrice }}
              </label>
          </div>

          <div class="form-group" v-html="cart.Product.Notes" v-if="cart.Product.Notes !== ''">                
          </div>

          <div class="form-group">
              <a href="#remove" @click="removeCart($event)">
                  <span class="glyphicon glyphicon-remove"></span>
                  {{ getLabel('_remove') }}
              </a>            
          </div>

          <div class="form-group">
              <hr />
          </div>

          <div v-if="cart.Product.IsCustom">
              <!-- Display groups if any -->
              <div v-for="group in cartGroups"
                   :key="group.Id">
                  <p>
                      <strong>
                          {{ getCustomerLabel(group.Label) }}
                      </strong>
                  </p>

                  <div class="table-responsive">
                      <table class="table">
                          <tbody>
                              <tr v-for="attribute in cart.Attributes" :key="attribute.Id" v-if="attribute.ProductAttributeGroupId == group.Id">
                                  <td>
                                      {{ getCustomerLabel(attribute.Label) }}
                                  </td>
                                  <td>
                                      <span v-if="attribute.Type !== 4" class="pull-right text-right">
                                          {{attribute.Value}}
                                      </span>

                                      <span v-if="attribute.Type == 4" class="pull-right text-right">
                                          <a :href="attribute.Value | correctImgUrl">
                                              {{ getLabel('attachment') }}
                                          </a>
                                      </span>
                                  </td>
                              </tr>
                          </tbody>
                      </table>
                  </div>                    
              </div>
              
              <div class="table-responsive">
                  <table class="table">
                      <tbody>
                          <tr v-for="attribute in cart.Attributes" :key="attribute.Id" v-if="attribute.ProductAttributeGroupId == 0">
                              <td>
                                  {{ getCustomerLabel(attribute.Label) }}
                              </td>
                              <td>
                                  <span v-if="attribute.Type !== 4" class="pull-right text-right">
                                      {{attribute.Value}}
                                  </span>

                                  <span v-if="attribute.Type == 4" class="pull-right text-right">
                                      <a :href="attribute.Value | correctImgUrl">
                                          {{ getLabel('attachment') }}
                                      </a>
                                  </span>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>

      </div>
  </li>
</template>
<script>
  import { store } from './../store.js';
  import { shared } from './../shared.js';
  import VeeValidate from 'vee-validate';

  export default {
      mixins: [shared],
      props: ['cart'],
      data: function () {
          return {
              state: store.state
          }
      },
      computed: {
          cartGroups: function () {
              var self = this;
              var groups = store.getAttributeGroups(self.cart);
              return groups;
          },
          productTitle: function () {

              var title = "";
              if (this.cart.Product.Collection != '') {
                  title = this.cart.Product.Collection + " - ";
              }
              
              title += this.cart.Product.Description + " - ";
              title += this.cart.Product.ItemCode;
              return title;
          },
          hasManufacturer: function () {
              var hasManufacturer = false;
              if (this.cart.Product.Manufacturer != '') {
                  hasManufacturer = true;
              }

              return hasManufacturer;
          },
          hasCustomFormat: function () {
              var hasCustomFormat = false;
              if (this.cart.Product.CustomFormat != '') {
                  hasCustomFormat = true;
              }

              return hasCustomFormat;
          },
          outOfStock: function () {
              var index = _.findIndex(this.state.storeSettings, function (o) {
                  return o.Key == 'oos-message';
              });

              var message = this.getLabel('web_outofstock');

              if (index != -1) {
                  var settingValue = this.state.storeSettings[index].Value;
                  message = settingValue != '' ? settingValue : message;
              }

              return message;
          }
      },
      methods: {
          removeCart: function (e) {
              e.preventDefault();
              store.removeCart(this.cart);              
          },
          updateCart: function (event) {
              var self = this;

              this.$validator.validateAll().then((isValid) => {
                  if (isValid) {
                      store.updateCart(self.cart);
                  }
              })
              
              event.preventDefault();
          }
      }
  };
</script>